import { BatchDeleteSpacesDto } from '@valuecase/common'
import { spacesApi } from '../../../api/spacesApi/spacesAPIclient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

function batchDeleteSpaces(dto: BatchDeleteSpacesDto) {
  return spacesApi.delete('/spaces/batch-delete', { data: dto })
}

export function useBatchDeleteSpaces() {
  const queryClient = useQueryClient()
  const mutation = useMutation<unknown, unknown, BatchDeleteSpacesDto>({
    mutationFn: batchDeleteSpaces,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['spaces'] })
    },
  })

  return {
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
    batchDeleteSpaces: (spaceRootNodeIds: string[]) => mutation.mutateAsync({ spaceRootNodeIds }),
  }
}
